import React from 'react';
import { LinkRow } from 'components';
import { FindLoad, PermissionList, RolePermission } from 'utils';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
// Import the standalone module directly (NOT a barrel): keeps this file out of the
// heavy claim/constants + pages-barrel import chains that trigger circular-dependency crashes.
import { OpenClaimDetails } from 'pages/billing/claim/openClaimDetails';

const ACTION_TYPE = 'GET_APPOINTMENT_INFORMATION';
export const ApptAccounting = ({ afterSuccess }) => {
    const { item } = useSelector((state) => ({
        item: state.appointment.apptAccounting,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const isNotEmpty = item && Object?.values(item)?.some((value) => value !== null && !(Array.isArray(value) && value.length === 0));

    if (loader?.length) {
        return (
            <div className="signature-process-loading">
                <Skeleton variant="rectangular" width={'100%'} height={73} style={{ borderRadius: 6 }} />
            </div>
        );
    }

    return (
        <>
            <div className="signature-process">
                <div className="flex-align-center" style={{ gap: 8 }}>
                    <p className="signature-detail-box-title">Accounting:</p>
                    {isNotEmpty ? (
                        <>
                            {!!item?.timesheets?.length && (
                                <div className="signature-detail-box">
                                    <div className="flex-align-center" style={{ gap: 4 }}>
                                        <p className="signature-detail-box-title">Timesheet:</p>
                                        {item?.timesheets?.map((timesheet, index) => (
                                            <p className="signature-detail-name" key={index}>
                                                <LinkRow
                                                    name={timesheet?.displayId ? timesheet?.displayId : '--'}
                                                    href={
                                                        RolePermission([PermissionList.TIMESHEET_READ?.code])
                                                            ? timesheet?.status === 'ACTIVE'
                                                                ? `/timesheet/${timesheet?.id}`
                                                                : `/processed/${timesheet?.id}`
                                                            : ''
                                                    }
                                                    checkPermission={
                                                        timesheet?.id ? RolePermission([PermissionList.TIMESHEET_READ?.code]) : null
                                                    }
                                                />
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {item?.claim?.id && (
                                <div className="signature-detail-box">
                                    <div className="flex-align-center" style={{ gap: 4 }}>
                                        <p className="signature-detail-box-title">Claim:</p>
                                        <p className="signature-detail-name">
                                            <OpenClaimDetails claimId={item?.claim?.id} displayId={item?.claim?.displayId} afterSuccess={afterSuccess} />
                                            {/*<LinkRow*/}
                                            {/*    name={item?.claim?.displayId ? item?.claim?.displayId : '--'}*/}
                                            {/*    href={RolePermission([PermissionList.CLAIMS_READ?.code]) ? `/claim/${item?.claim?.id}` : ''}*/}
                                            {/*    checkPermission={*/}
                                            {/*        item?.claim?.id ? RolePermission([PermissionList.CLAIMS_READ?.code]) : null*/}
                                            {/*    }*/}
                                            {/*/>*/}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {item?.bill?.id && (
                                <div className="signature-detail-box">
                                    <div className="flex-align-center" style={{ gap: 4 }}>
                                        <p className="signature-detail-box-title">Bill:</p>
                                        <p className="signature-detail-name">
                                            <OpenClaimDetails claimId={item?.bill?.id} displayId={item?.bill?.displayId} afterSuccess={afterSuccess} />
                                            {/*<LinkRow*/}
                                            {/*    name={item?.bill?.displayId ? item?.bill?.displayId : '--'}*/}
                                            {/*    href={RolePermission([PermissionList.CLAIMS_READ?.code]) ? `/claim/${item?.claim?.id}` : ''}*/}
                                            {/*    checkPermission={*/}
                                            {/*        item?.claim?.id ? RolePermission([PermissionList.CLAIMS_READ?.code]) : null*/}
                                            {/*    }*/}
                                            {/*/>*/}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {item?.invoice?.id && (
                                <div className="signature-detail-box">
                                    <div className="flex-align-center" style={{ gap: 4 }}>
                                        <p className="signature-detail-box-title">Invoice:</p>
                                        <p className="signature-detail-name">
                                            <LinkRow
                                                name={item?.invoice?.displayId ? item?.invoice?.displayId : '--'}
                                                href={
                                                    RolePermission([PermissionList.INVOICE_READ?.code])
                                                        ? `/invoice/${item?.invoice?.id}`
                                                        : ''
                                                }
                                                checkPermission={
                                                    item?.invoice?.id ? RolePermission([PermissionList.INVOICE_READ?.code]) : null
                                                }
                                            />
                                        </p>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <p className="signature-detail-name">Not Yet</p>
                    )}
                </div>
            </div>
        </>
    );
};
